import { SalesByCustomerRoute, SalesPerMonth, SalesPerWeek } from "../../components/TableDetailSalesPerRoute/Class";
import { ActualDate, DateFormatMAS90, getActualDateUTC, getWeekNumber } from "../../functions/dateFormat";
import { intervalTimeInDays, intervalTimeInDays2, MonthInLetters, NameSalesPerson, NumberFormat, random_rgba } from "../../functions/generalFunctions";
import { pricesFormat } from "../../functions/pricesFormat";
import { getIndexElement } from "../../functions/searchInObject";
import { getInformationWithDataDashboard as getInformationWithData, getInformationWithDataGlobalSalesDashboard as getInformationWithDataGlobalSales, getInformationWithDataB1, getInformationWithDataV3 } from "../../services/CABE";
import { getValueCookie } from "../../services/cookieService";
import { GeneralFormatToSend, SalesPerRouteMonth, TitlesSalesPerRoutes, CustomerInvoicesFormatToSend } from "./Class";
import { SalesPerCalendarSeptember, SalesPerSeptember } from "./temporalInfoJDL";
import React from "react";

export async function getSalesOrdersPerUser(SalesPerson) {
    const data = {
        SalespersonNo: SalesPerson ? SalesPerson : getValueCookie('SalesPerson'),
        idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
        CustomerNo: '*'
    }

    // Request from endpoints V2
    const SalesOrder = await getInformationWithData('/sales/get/headerV2', data);
    const Invoices = await getInformationWithData('/invoice/headerV2', data);

    if (SalesOrder.status.code === 1) {
        for (const order of SalesOrder.data) {
            order.ColorRow = intervalTimeInDays(order.OrderDate, ActualDate()) >= 7 ? "grayTableCell" : (intervalTimeInDays(order.OrderDate, ActualDate()) > 5 ? "yellowTableCell" : "greenTableCell")
            order.OrderDate = DateFormatMAS90(order.OrderDate)
            order.TypeinLetters = order.OrderType === 'S' ? "Standard" : "Quote"
            order.ExistInv = getIndexElement(Invoices.data, 'SalesOrderNo', order.SalesOrderNo) === -1 ? 'No' : 'Yes'
            order.DaysSystem = intervalTimeInDays(order.OrderDate, ActualDate())
            order.StatusColor = ((!order.Status) || (order.Status === 0)) ? "text-danger" : (order.Status === 1 ? "text-warning" : "text-success")
            order.StatusText = ((!order.Status) || (order.Status === 0)) ? "Not started" : (order.Status === 1 ? "In process" : "Finished")
        }
        return SalesOrder.data;
    } else {
        return []
    }
}

export async function getSalesPerRoute(SalesPerson, DateC) {
    let colorsRoute = [
        { Ruta: 'Warehouse',   Color: '#004C94' },
        { Ruta: 'Supermarket', Color: '#73CC80' },
        { Ruta: 'Distributor', Color: '#3C93FA' },
        { Ruta: 'Pallet',      Color: '#028183' }
    ];
    let temp = new Date();
    //let Start = new Date(temp.getFullYear(), temp.getMonth(), 1)
    let Start = new Date(temp.getFullYear(), temp.getMonth(), 1);
    let End = new Date(temp.getFullYear(), temp.getMonth() + 1, 0);

    if (DateC) {
        Start = new Date(DateC.getFullYear(), DateC.getMonth(), 1);
        End = new Date(DateC.getFullYear(), DateC.getMonth() + 1, 0);
    }


    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'), Start.toISOString().split('T')[0], End.toISOString().split('T')[0], (Start.getMonth() + 1))

    // V1
    // V2 - RDS mirror (replaces slow WS-based V1)
    const result = await getInformationWithData('/invoice/get/Total/byRouteV2', data);

    const result2 = await getInformationWithData('/reports/getMeta', data);
    if (SalesPerson === 'JDL' && Start.getMonth() === 9) {
        result.data = result.data.concat(SalesPerSeptember);
    }
    let TotalMeta = 0;
    let GeneralTotal = 0;
    result.data.forEach(element => {
        GeneralTotal += Number(element.NonTaxableSalesAmt);
    })
    result2.data.forEach(element => {
        TotalMeta += Number(element.Meta);
    });
    let processInfo = [];
    let Months = new TitlesSalesPerRoutes(false, (Start.getMonth() + 1));

    if (result.status.code === 1 && result2.status.code === 1) {
        // FIXED - Added an if by data type
        if (Array.isArray(result.data)) {
            result.data.forEach(row => {
                const indexMeta = getIndexElement(result2.data, 'Ruta', row.UDF_RUTA);
                const index = getIndexElement(processInfo, 'Name', row.UDF_RUTA);
                // const date = row.InvoiceDate.split('-')
                // FIXED 
                const date = row.InvoiceDate ? row.InvoiceDate.split('-') : [];

                if (date.length === 3) {
                    const index2 = getIndexElement(Months, 'Month', MonthInLetters(date[1]));
                    let total = 0;
                    if (index2 !== -1) {
                        Months[index2].Total += (Number(row.NonTaxableSalesAmt));
                        Months[index2].TotalMeta = TotalMeta;
                        total = Months[index2].Total;
                    }

                    let to = 0;
                    if (index !== -1) {

                        to = processInfo[index].addData(MonthInLetters(date[1]), row.NonTaxableSalesAmt, indexMeta !== -1 ? result2.data[indexMeta].Meta : 0);
                        processInfo[index].addRow(row);

                    } else {
                        let newRoute = new SalesPerRouteMonth(row.UDF_RUTA, (Start.getMonth() + 1));
                        newRoute.addRow(row);
                        to = newRoute.addData(MonthInLetters(date[1]), row.NonTaxableSalesAmt, indexMeta !== -1 ? result2.data[indexMeta].Meta : 0);

                        processInfo.push(newRoute);
                    }


                    for (const route of processInfo) {
                        const indexMonth = getIndexElement(route.Data, 'Month', MonthInLetters(date[1]));
                        if (indexMonth !== -1 && to > 0) {

                            route.Data[indexMonth].Percentage = Number(total) > 0 ? ((Number(route.Data[indexMonth].Total) / Number(total)) * 100) : 0
                            route.Data[indexMonth].PercentageMeta = TotalMeta > 0 ? ((Number(route.Data[indexMonth].TotalMeta) / TotalMeta) * 100) : 0
                            route.Data[indexMonth].PercentageComplete = Number(route.Data[indexMonth].TotalMeta) > 0 ? ((Number(route.Data[indexMonth].Total)) / (Number(route.Data[indexMonth].TotalMeta))) * 100 : 0
                            if (route.Data[indexMonth].PercentageComplete < 30) {
                                route.Color = 'grayTableCell';
                            } else if (route.Data[indexMonth].PercentageComplete < 99) {
                                route.Color = 'yellowTableCell';
                            } else {
                                route.Color = 'greenTableCell';
                            }

                        }
                    }



                    if (index2 !== -1) {
                        const indexColor = getIndexElement(colorsRoute, 'Ruta', row.UDF_RUTA)
                        if (indexColor !== -1) {
                            Months[index2].addRoute(row.UDF_RUTA, GeneralTotal > 0 ? (to / GeneralTotal) * 100 : 0, row.UDF_RUTA, colorsRoute[indexColor].Color);
                        } else {
                            Months[index2].addRoute(row.UDF_RUTA, GeneralTotal > 0 ? (to / GeneralTotal) * 100 : 0, row.UDF_RUTA, random_rgba());
                        }

                    }


                }

            });
        }
    }

    processInfo = processInfo.sort((a, b) => {
        return a.Data[0].Total < b.Data[0].Total ? 1 : a.Data[0].Total > b.Data[0].Total ? -1 : 0;
    });



    return { Information: processInfo, Months: Months };
}

export async function getSalesPerRouteAllYear(){
    const result = await getInformationWithData('/Invoice/SalesByRouteYearV2', { idCompany: Number(getValueCookie('CompanyId')) })
    if(result.status.code===1){
        // The API returns way more history than the chart needs (e.g. 19 months) —
        // keep only the last 13 months (current month + the prior 12), so if today
        // is July 2026 the range shown is June 2025 through July 2026.
        const now = new Date()
        const currentMonthKey = now.getFullYear() * 12 + now.getMonth()
        const MONTHS_TO_SHOW = 13
        for (const Warehouse of result.data) {
            Warehouse.Detail = (Warehouse.Detail || [])
                .filter((Line) => {
                    const lineMonthKey = Number(Line.Year) * 12 + (Number(Line.MonthNo) - 1)
                    const monthsAgo = currentMonthKey - lineMonthKey
                    return monthsAgo >= 0 && monthsAgo < MONTHS_TO_SHOW
                })
                .sort((a, b) => (Number(a.Year) * 12 + Number(a.MonthNo)) - (Number(b.Year) * 12 + Number(b.MonthNo)))
        }

        for (const Warehouse of result.data) {
            let Total = 0;
            for (const Line of Warehouse.Detail) {
                Total += Line.Total;
            }
            Warehouse.Total = Total;
        }
            let flag = true;
          for (const Warehouse of result.data) {
            if(Warehouse.Route==='Total'){
                flag = true;
                
            }else{
                flag = false;
            }

            let labels = [];
            let data = [];
            let data2 = [];
            let colors = [
                'rgba(37,  99,  235, 0.82)',
                'rgba(16,  185, 129, 0.82)',
                'rgba(245, 158, 11,  0.82)',
                'rgba(139, 92,  246, 0.82)',
                'rgba(239, 68,  68,  0.82)',
                'rgba(6,   182, 212, 0.82)',
                'rgba(249, 115, 22,  0.82)',
                'rgba(20,  184, 166, 0.82)',
                'rgba(99,  102, 241, 0.82)',
                'rgba(236, 72,  153, 0.82)',
                'rgba(132, 204, 22,  0.82)',
                'rgba(234, 179, 8,   0.82)'
            ];
            for (const Line of Warehouse.Detail) {
                labels.push(`${Line.MonthNo}/${Line.Year}`)
                data.push(Line.Total)
                //colors.push(random_rgba())
                if(flag){
                    data2.push(Line.Total)
                    
                }else{
                    data2.push((Line.Total/Warehouse.Total)*100)
                }
                
            }



            Warehouse.Graph={
                options:{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'top',
                      },
                      title: {
                        display: true,
                        text: 'Sales of '+Warehouse.Route,
                      },
                      tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ': $ ';
                                }
                                label += NumberFormat(pricesFormat(parseFloat(context.parsed.y.toString().replace(/,/g, '.')))) ;
    
                                return label;
                            },
                        },
                    },
                    },
                    scales: {
                        y:{
                            ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return '$' + NumberFormat(Number(value).toFixed(0));
                                }
                            }
                        }
                    }
                  },
                  data:{
                    labels:labels,
                    datasets:[{
                        label:'Sales',
                        data:data,
                        backgroundColor:colors
                    }]
                  },
                  reference:React.createRef()

            }
            let LineColor='rgba(37, 99, 235, 0.85)'
            Warehouse.Line={
                options:{
                    responsive: true,
                    plugins: flag?{
                        legend: {
                          position: 'top',
                        },
                        title: {
                          display: true,
                          text: 'Sales of '+Warehouse.Route,
                        },
                        tooltip: {
                          callbacks: {
                              label: function (context) {
                                  let label = context.dataset.label || '';
                                  if (label) {
                                      label += ': $ ';
                                  }
                                  label += NumberFormat(pricesFormat(parseFloat(context.parsed.y.toString().replace(/,/g, '.')))) ;
                                  
                                  return label;
                              },
                          },
                      },
                      }:{
                      legend: {
                        position: 'top',
                      },
                      title: {
                        display: true,
                        text: flag?Warehouse.Route:'Sales of '+Warehouse.Route,
                      },
                      tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ':';
                                }
                                label += NumberFormat(pricesFormat(parseFloat(context.parsed.y.toString().replace(/,/g, '.')))) ;
                                label += "%"
                                return label;
                            },
                        },
                    },
                    },
                    scales: flag?{
                        y:{
                            ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return '$' + (pricesFormat(value));
                                }
                            }
                        }
                    }:{
                        y:{
                            ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return (Number(value).toFixed(0))+"%";
                                }
                            }
                        }
                    }
                  },
                  data:{
                    labels:labels,
                    datasets:[{
                        label:'Sales',
                        
                        spanGaps: true,
                        data:data2,
                        backgroundColor:LineColor,
                        borderColor:LineColor
                    }]
                  }
            }

          }
          
        return result.data
    }
    return []
    
}

async function sendRequest(url, data) {
    for(let i = 0; i < 3; i++){
        try {
            const response = await getInformationWithData(url, data)
            return response;
        }
        catch(error){
            console.log("Error")
        }
    }
}

export async function getSalesPerSalesPerson(SalesPerson, DateC) {
    let colorsRoute = [
        { Ruta: NameSalesPerson('AM'),   Color: 'rgba(37,  99,  235, 0.85)' },
        { Ruta: NameSalesPerson('RR'),   Color: 'rgba(16,  185, 129, 0.85)' },
        { Ruta: NameSalesPerson('0000'), Color: 'rgba(245, 158, 11,  0.85)' },
        { Ruta: NameSalesPerson('0010'), Color: 'rgba(139, 92,  246, 0.85)' }
    ]
    let temp = new Date()
    let Start = new Date(temp.getFullYear(), temp.getMonth(), 1)
    let End = new Date(temp.getFullYear(), temp.getMonth() + 1, 0)

    if (DateC) {
        Start = new Date(DateC.getFullYear(), DateC.getMonth(), 1)
        End = new Date(DateC.getFullYear(), DateC.getMonth() + 1, 0)
    }


    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'), Start.toISOString().split('T')[0], End.toISOString().split('T')[0], (Start.getMonth() + 1))
    
    let result = await sendRequest('/invoice/get/Total/byRouteV2', data)
    const result2 = await sendRequest('/reports/getMetaGroupBySalesPersonV2', data)

    let TotalMeta = 0
    let GeneralTotal = 0
    result.data.forEach(element => {
        GeneralTotal += Number(element.NonTaxableSalesAmt)
    })
    result2.data.forEach(element => {
        TotalMeta += Number(element.Meta)
    });
    let processInfo = []
    let Months = new TitlesSalesPerRoutes(false, (Start.getMonth() + 1), "SP")

    if (result.status.code === 1 && result2.status.code === 1) {

        result.data.forEach(row => {
            const indexMeta = getIndexElement(result2.data, 'Ruta', row.SalespersonNo)
            const index = getIndexElement(processInfo, 'Name', NameSalesPerson(row.SalespersonNo === "WW"&&getValueCookie('CompanyId')==='3' ? '0000' : row.SalespersonNo))
            // const date = row.InvoiceDate.split('-')
            // Fixed
            const date = row.InvoiceDate ? row.InvoiceDate.split('-') : [];
            if (date.length === 3) {
                const index2 = getIndexElement(Months, 'Month', MonthInLetters(date[1]))
                let total = 0
                if (index2 !== -1) {
                    Months[index2].Total += (Number(row.NonTaxableSalesAmt))
                    Months[index2].TotalMeta = TotalMeta
                    total = Months[index2].Total
                }

                let to = 0
                if (index !== -1) {

                    to = processInfo[index].addData(MonthInLetters(date[1]), row.NonTaxableSalesAmt, indexMeta !== -1 ? result2.data[indexMeta].Meta : 0, "SP")
                    processInfo[index].addRow(row)

                } else {
                    let newRoute = new SalesPerRouteMonth(NameSalesPerson(row.SalespersonNo === "WW"&&getValueCookie('CompanyId')==='3' ? '0000' : row.SalespersonNo), (Start.getMonth() + 1), "SP")
                    newRoute.addRow(row)
                    to = newRoute.addData(MonthInLetters(date[1]), row.NonTaxableSalesAmt, (indexMeta !== -1 ? result2.data[indexMeta].Meta : 0), "SP")

                    processInfo.push(newRoute)
                }


                for (const route of processInfo) {
                    const indexMonth = getIndexElement(route.Data, 'Month', MonthInLetters(date[1]))
                    if (indexMonth !== -1 && to > 0) {

                        route.Data[indexMonth].Percentage = Number(total) > 0 ? ((Number(route.Data[indexMonth].Total) / Number(total)) * 100) : 0
                        route.Data[indexMonth].PercentageMeta = TotalMeta > 0 ? ((Number(route.Data[indexMonth].TotalMeta) / TotalMeta) * 100) : 0
                        route.Data[indexMonth].PercentageComplete = Number(route.Data[indexMonth].TotalMeta) > 0 ? ((Number(route.Data[indexMonth].Total)) / (Number(route.Data[indexMonth].TotalMeta))) * 100 : 0
                        if (route.Data[indexMonth].PercentageComplete < 30) {
                            route.Color = 'grayTableCell'
                        } else if (route.Data[indexMonth].PercentageComplete < 99) {
                            route.Color = 'yellowTableCell'
                        } else {
                            route.Color = 'greenTableCell'
                        }

                    }
                }



                if (index2 !== -1) {
                    const indexColor = getIndexElement(colorsRoute, 'Ruta', NameSalesPerson(row.SalespersonNo === "WW"&&getValueCookie('CompanyId')==='3' ? '0000' : row.SalespersonNo))
                    if (indexColor !== -1) {
                        Months[index2].addRoute(NameSalesPerson(row.SalespersonNo === "WW" ? '0000' : row.SalespersonNo), GeneralTotal > 0 ? (to / GeneralTotal) * 100 : 0, NameSalesPerson(row.SalespersonNo === "WW"&&getValueCookie('CompanyId')==='3' ? '0000' : row.SalespersonNo), colorsRoute[indexColor].Color)
                    } else {
                        Months[index2].addRoute(NameSalesPerson(row.SalespersonNo === "WW" ? '0000' : row.SalespersonNo), GeneralTotal > 0 ? (to / GeneralTotal) * 100 : 0, NameSalesPerson(row.SalespersonNo === "WW"&&getValueCookie('CompanyId')==='3' ? '0000' : row.SalespersonNo), random_rgba())
                    }

                }


            }

        });



    }

    processInfo = processInfo.sort((a, b) => {
        return a.Data[0].Total < b.Data[0].Total ? 1 : a.Data[0].Total > b.Data[0].Total ? -1 : 0;
    });
    return { Information: processInfo, Months: Months }
}

export async function getCustomerExcess(SalesPerson) {
    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'))
    const result = await getInformationWithData('/customer/get/CarteraV2', data)

    if (result.status.code === 1) {
        return result.data
    } else {
        return []
    }
}

export async function getCurrentBalance(SalesPerson) {
    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'))
    // V1 (WS-dependent — backup): const result = await getInformationWithDataB1('/customer/getBalance', data)
    // V2 (RDS):
    const result = await getInformationWithData('/customer/getBalanceV2', data)
    if (result.status.code === 1) {
        let actualDate = ActualDate()
        let info = []
        for (const invoice of result.data) {
            if (intervalTimeInDays2(actualDate, DateFormatMAS90(invoice.InvoiceDueDate)) <= 0) {
                invoice.DaysDlq = intervalTimeInDays(invoice.InvoiceDueDate, getActualDateUTC())
                info.push(invoice)
            }
        }
        return info
    } else {
        return []
    }
}

export async function getCustomerHistory(SalesPerson) {
    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'))
    // V1
    // const result = await getInformationWithDataGlobalSales('/user/History', data)
    // const result2 = await getInformationWithDataGlobalSales('/user/NotesLastMonth',data)
    // V2
    const result = await getInformationWithData('/user/HistoryV2', data)
    const result2 = await getInformationWithData('/user/NotesLastMonthV2',data)

    if (!result || result.status.code !== 1) return []
    const customers = result.data || []
    for (const customer of customers) {
        const index = getIndexElement(result2 && result2.data ? result2.data : [], 'CustomerNo', customer.CustomerNo)
        customer.NumberDays = customer.DateLastActivity ? NumberFormat(Number(intervalTimeInDays(customer.DateLastActivity, getActualDateUTC())) - 1) : "Never"
        customer.HaveNotes = index !== -1
    }
    return customers
}

export async function getSalesByCustomer(SalesPerson, DateC) {

    let temp = new Date()
    let Start = new Date(temp.getFullYear(), temp.getMonth(), 1)
    let End = new Date(temp.getFullYear(), temp.getMonth() + 1, 0)

    if (DateC) {
        Start = new Date(DateC.getFullYear(), DateC.getMonth(), 1)
        End = new Date(DateC.getFullYear(), DateC.getMonth() + 1, 0)
    }


    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'), Start.toISOString().split('T')[0], End.toISOString().split('T')[0], (Start.getMonth() + 1))

    const result = await getInformationWithData('/invoice/get/Total/byRouteV2', data)
    if (SalesPerson === 'JDL' && Start.getMonth() === 9) {
        result.data = result.data.concat(SalesPerSeptember)
    }
    if (result.status.code === 1) {
        let info = new SalesByCustomerRoute()
        for (const Customer of result.data) {
            info.addCustomer(Customer.CustomerNo, Customer.BillToName, Customer.NonTaxableSalesAmt, Customer.UDF_RUTA, Customer)
        }
        info.finalize()
        return info.Data
    }
    return []
}

export async function getSalesPerMonth(SalesPerson, DateC) {
    let actualDate = new Date()

    let Start = new Date(actualDate.getFullYear(), actualDate.getMonth(), 1)
    let End = new Date(actualDate.getFullYear(), actualDate.getMonth() + 1, 0)

    if (DateC) {
        Start = new Date(DateC.getFullYear(), DateC.getMonth(), 1)
        End = new Date(DateC.getFullYear(), DateC.getMonth() + 1, 0)
    }

    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'), Start.toISOString().split('T')[0], End.toISOString().split('T')[0], (Start.getMonth() + 1))

    // V1 (global API — SAGE live via WS). Timeout 8s: si el WS está colgado no bloquea indefinidamente.
    const v1WithTimeout = Promise.race([
        getInformationWithDataGlobalSales('/Sales/actualMonth', data),
        new Promise(resolve => setTimeout(() => resolve(null), 8000))
    ]);
    let result = await v1WithTimeout;

    // Si V1 no respondió a tiempo, falló, o no tiene keys numéricas → fallback a V2 (RDS mirror)
    const hasV1Data = result && typeof result === 'object' && !Array.isArray(result)
        && Object.keys(result).some(k => !isNaN(Number(k)));
    if (!hasV1Data) {
        // 2026-09-02 fix: Altitude (idCompany=6) used to fall back to
        // /Sales/actualMonthV2 (alt_controllers/sales.ts), whose query reads
        // Mayaland's own mirror tables (no alt__ prefix) — an Altitude user
        // would see Mayaland's invoice totals under their own dashboard
        // ("Errores Sistema 09-02-26" PPTX, slide 1). Mayaland/Nebraska keep
        // using the original endpoint unchanged; only Altitude repoints to
        // the corrected v3 clone (v3_controllers/salesReports.ts).
        if (data.idCompany === 6) {
            const v3Result = await getInformationWithDataV3('/sales/actual-month', data);
            // v3Result.data is a flat array of invoice rows (CustomerNo, InvoiceDate,
            // NonTaxableSalesAmt, ...) — the rest of this function expects an object
            // keyed by day-of-month (the shape V1's live SAGE call naturally returns).
            // The old /Sales/actualMonthV2 path returned the same flat-array shape and
            // was NEVER bucketed either — its result silently produced [] below (empty
            // numeric-key filter), which is why the RDS fallback always showed $0.00
            // regardless of which company's tables it queried. Bucket it here so
            // Altitude's fallback actually surfaces real data.
            const rows = (v3Result && v3Result.status && v3Result.status.code === 1 && Array.isArray(v3Result.data)) ? v3Result.data : [];
            const byDay = {};
            for (const row of rows) {
                const day = String(row.InvoiceDate).slice(8, 10); // 'YYYY-MM-DD' -> 'DD'
                if (!byDay[day]) {
                    byDay[day] = { NonTaxableSalesAmt: { total: 0 }, registros: 0, detail: [] };
                }
                byDay[day].NonTaxableSalesAmt.total += Number(row.NonTaxableSalesAmt) || 0;
                byDay[day].registros += 1;
                byDay[day].detail.push(row);
            }
            result = byDay;
        } else {
            result = await getInformationWithData('/Sales/actualMonthV2', data);
        }
    }
    if (SalesPerson === 'JDL' && Start.getMonth() === 9) {
        result["01"] = SalesPerCalendarSeptember["01"]
    }

    // Guard: if result is an error object or has no numeric day keys, return empty
    if (!result || typeof result !== 'object' || Array.isArray(result)) return []

    const keys = Object.keys(result).filter(k => !isNaN(Number(k)))
    let processData = []
    for (const key of keys) {
        const dayData    = result[key] || {};
        const salesAmt   = dayData.NonTaxableSalesAmt || { total: 0 };
        const total      = Number(salesAmt.total) || 0;
        const registros  = dayData.registros || 0;
        const detail     = dayData.detail    || [];

        processData.push(new SalesPerMonth(Number(key), total, registros, detail))
        let week = getWeekNumber(new Date((Start.getMonth() + 1) + "/" + key + "/" + Start.getFullYear()))
        const index = await getIndexElement(processData, 'Week', String(week))
        if (index !== -1) {
            await processData[index].addInfo(total, registros, detail)
        } else {
            let newWeek = new SalesPerWeek(week)
            await newWeek.addInfo(total, registros, detail)
            await processData.push(newWeek)
        }
    }


    return processData
}

export async function getShorts(SalesPerson) {
    const data = new GeneralFormatToSend(getValueCookie('CompanyId'), SalesPerson ? SalesPerson : getValueCookie('SalesPerson'));
    // V1 (global api — backup): const result = await getInformationWithDataGlobalSales('/invoice/AvailableShorts', data);
    // V2 (RDS):
    const result = await getInformationWithData('/invoice/AvailableShortsV2', data);

    if (result && result.status && result.status.code === 1) {
        // Transform flat array → object keyed by ItemCode (same shape TableShortView expects)
        const grouped = {};
        for (const row of result.data) {
            if (!grouped[row.ItemCode]) {
                grouped[row.ItemCode] = {
                    ItemCodeDesc: row.ItemCodeDesc,
                    TotalQuantityOnHand: row.TotalQuantityOnHand,
                    shorts: { total: 0 },
                    detail: []
                };
            }
            grouped[row.ItemCode].shorts.total += Number(row.shorts) || 0;
            grouped[row.ItemCode].detail.push(row);
        }
        const sorted = Object.entries(grouped);
        sorted.sort((a, b) => b[1].shorts.total - a[1].shorts.total);
        return Object.fromEntries(sorted);
    } else {
        return {}
    }
}

export async function getAltitudeInvReceipts(Start, End) {
    const data = new CustomerInvoicesFormatToSend(Start, End)
    return await getInformationWithData('/invoices/invoice-cash-receiptsV2', data);
}

